/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundEnumsDto } from '../../models/backend-own-fund-enums-dto';

export interface FinancingSourcesOwnFundsEnumsRetrieve$Params {}

export function financingSourcesOwnFundsEnumsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: FinancingSourcesOwnFundsEnumsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundEnumsDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsEnumsRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundEnumsDto>;
    }),
  );
}

financingSourcesOwnFundsEnumsRetrieve.PATH = '/api/financing_sources/own_funds/enums/';
